<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          class="text-unset"
          v-on="on"
          v-on:click="click"
          :disabled="disabled"
          >{{ buttonText }}</v-btn
        >
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ $t("shop-ticket-send-title") }}
        </v-card-title>

        <v-card-text v-if="isLoading == true">
          {{ $t("shop-ticket-data-loading") }}
        </v-card-text>

        <v-card-text v-if="isLoading == false">
          <b-form-group :label="$t('shop-ticket-send-title')">
            <v-autocomplete
              v-model="user"
              :label="$t('user')"
              persistent-hint
              :items="options_usernames"
              item-text="username"
              return-object
              item-value="id"
            ></v-autocomplete>
          </b-form-group>
        </v-card-text>

        <v-card-text v-if="isLoading == false">
          <b-form-group :label="$t('shop-ticket-send-quantity')">
            <b-form-select
              id="inline-form-custom-select-pref"
              class="mb-2 mr-sm-2 mb-sm-0"
              :options.sync="options"
              :value="null"
              v-model="quantity"
            ></b-form-select>
          </b-form-group>
        </v-card-text>

        <v-card-text v-if="user && quantity &gt; 0">
          {{
            $tc("shop-ticket-send-confirm", quantity, {
              count: quantity,
              1: user.username,
            })
          }}
        </v-card-text>

        <v-card-actions v-if="isLoading == false">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" class="text-unset">
            {{ $t("common.back") }}
          </v-btn>
          <v-btn
            v-if="shopItemTxtId != null"
            color="error"
            text
            @click="send"
            class="text-unset"
            :isLoading="isLoading"
          >
            {{ $tc("shop-ticket-send-x", quantity, { count: quantity }) }}
          </v-btn>
          <v-btn v-else color="error" text @click="send" class="text-unset">
            {{ $tc("shop-ticket-send-x", quantity, { count: quantity }) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

export default {
  props: [
    "price",
    "disabled",
    "shopItemTxtId",
    "ticketsBought",
    "downline",
    "upline",
    "buttonText",
  ],
  data() {
    return {
      dialog: false,
      quantity: 0,
      user: null,
      isLoading: true,
      options_usernames: null,
    };
  },
  computed: {
    ...mapGetters({
      available: "user/available",
      htlEur: "prices/htlEur",
      rate: "prices/rate",
    }),
    options: function () {
      return [...Array.from({ length: this.ticketsBought }, (_, i) => i + 1)];
    } /*,
        options_usernames: ()=> {
            return[...this.downline.map(f => {return f.username;})]
        }*/,
  },
  methods: {
    click() {
      var token = localStorage.getItem("apollo-token");
      this.axios
        .get(this.baseURL + "/admin-api/v1/u/downline?access_token=" + token)
        .then((response) => {
          this.isLoading = false;
          this.options_usernames = response.data;
          console.log(response);
        });
    },
    send() {
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($quantity: Int!, $user: ID!, $shopItemTxtId: String!) {
              sendTicket(
                quantity: $quantity
                user: $user
                shopItemTxtId: $shopItemTxtId
              )
            }
          `,
          // Parameters
          variables: {
            quantity: this.quantity,
            user: this.user.id,
            shopItemTxtId: this.shopItemTxtId,
          },
        })
        .then(() => {
          this.$router.go(0);
        });
    },
    //infotrend
    buyButNormal() {
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation (
              $token: String!
              $quantity: Int!
              $shopItemTxtId: String!
            ) {
              buyTicketButNormal(
                token: $token
                quantity: $quantity
                shopItemTxtId: $shopItemTxtId
              )
            }
          `,
          // Parameters
          variables: {
            token: this.rate,
            quantity: this.quantity,
            shopItemTxtId: this.shopItemTxtId,
          },
        })
        .then(() => {
          this.$router.go(0);
        });
    },
  },
};
</script>

